import AccountSwitchScreen from './AccountSwitchScreen';

export default AccountSwitchScreen;
export { reloadAfterForeignAccountChange } from './accountSwitch';
/** @internal для тестов приложений */
export { resetAccountSwitch } from './accountSwitch';
export type { IAccountsPort } from './accountsPort';
